// Pre-launch access gate (Visitor opens to end users ~2027).
// Until then only allowlisted admin emails may hold an authenticated
// (non-anonymous) session in the Marketplace app. Anonymous guest sessions
// and QR / deep-link test entries are intentionally untouched.

export const PRELAUNCH_ADMIN_EMAILS: string[] = ['admin@c0menius.app'];

export const BEEHIIV_LOADER_URL = 'https://subscribe-forms.beehiiv.com/v3/loader.js';
export const BEEHIIV_FORM_ID = 'ef232b3c-d7e0-4713-b35a-875e9c2b1376';

export function isPrelaunchAdminEmail(email: unknown): boolean {
  if (typeof email !== 'string') return false;
  const norm = email.trim().toLowerCase();
  if (!norm) return false;
  return PRELAUNCH_ADMIN_EMAILS.includes(norm);
}

export function isPrelaunchAdminUser(user: any): boolean {
  if (!user || user.isAnonymous) return false;
  return isPrelaunchAdminEmail(user?.email);
}

// QR / deep-link test entries (and AR returns) bypass the prelaunch gate
// entirely — live testing on any host keeps working without an account.
export function isQrEntry(): boolean {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('experience') || params.get('exhibitionId')) return true;
    if (params.get('museum') || params.get('mid') || params.get('screen')) return true;
    const raw = sessionStorage.getItem('comenius_ar_return');
    if (raw) {
      const state = JSON.parse(raw);
      if (Date.now() - (state.timestamp || 0) < 900_000) return true;
    }
  } catch {}
  return false;
}
